export default {
  home: {
    DownloadApp: "Télécharger l'application",
    DIRECTRENT: 'LOCATION DIRECTE',
    minute: 'minute',
    price_info: '{mianfei} minutes gratuites, maximum par jour {currencyName}{fengding}, caution {currencyName}{yajin}, caution de loyer gratuite',
    feature_1: 'Conception spéciale pour le chargement sans fil',
    feature_2: 'Emprunt et remboursement universels nationaux',
    feature_3: 'Quatre modes de chargement, adaptés à tous les téléphones mobiles',
    submit: 'Recharger',
    borrow: 'Emprunter',
    inputcodetitle: "Veuillez saisir le numéro de l'appareil sur l'armoire",
    msg_rentcount: 'Vous avez actuellement {zujieNum} commandes qui ne sont pas clôturées.',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    msg_fail_title: 'Erreur',
    msg_fail_content: 'La location a échoué, veuillez réessayer',
    shoptime: 'Temps de travail',
    supportrental: 'Location de support',
    supportreturn: 'Retour de support',
    useragreen: "Cliquez pour accepter le « Formulaire d'autorisation de débit délégué », « Contrat d'utilisation », « Contrat de recharge",
    privacyagreen: "Cliquez pour accepter l'accord de confidentialité",
    offline: "L'appareil {devicecode} est hors ligne, veuillez contacter le personnel présent",
    permissionfail: 'Permission refusée.',
    unbound: "Le code QR Mix {devicecode} n'est pas lié à l'appareil",
    nobattery: "Aucune batterie disponible dans l'appareil {devicecode}",
    分钟: 'minute',
    小时: 'heure',
    天: 'jour'
  },
  loginborrow: {
    start: "Commencer",
    powerbanktitle: "Débloquez la banque d'alimentation Voozaa",
    msg_fail_title: 'Erreur',
    msg_fail_user: "Erreur lors de l'obtention des informations utilisateur. Voulez-vous essayer à nouveau?",
    msg_rentcount: 'Vous avez actuellement {zujieNum} commandes qui ne sont pas clôturées.',
    msg_fail_support: "Le système n'est pas pris en charge",
    msg_fail_confirm: 'Confirmer',
    msg_fail_retry: 'Recommencez',
    msg_fail_cancel: 'Annuler',
    msg_fail_order: 'Échec de la création de la commande de location',
    msg_fail_paymod: "Impossible d'obtenir le mode de paiement",
    msg_fail_login: 'La connexion a échoué',
    Apple: 'Pomme',
    otheropt: 'Autres options',
    selectmethod: 'Sélectionnez votre méthode de paiement',
    paymentdetail: 'Détails du mode de paiement',
    couponcode: 'Code promo',
    rent: 'Confirmer le paiement',
    pricing: 'Voir les tarifs',
    phone: 'Téléphone',
    Google: 'Google',
    Facebook: 'Facebook',
    loginfb: 'Connectez-vous avec Facebook',
    logingg: 'Connectez-vous avec Google',
    captcha_code: 'Code',
    phonenumber: 'Entrez votre numéro de téléphone',
    msg_fail_code: "entrez le code de vérification S'il vous plait",
    msg_fail_phone: 'Veuillez entrer votre numéro de téléphone',
    logout: 'Quitter le compte',
    savenow: 'Sauvegarder maintenant',
    delete: 'Supprimer',
    addcard: 'Entrez les détails de la carte',
    msg_fail_content: 'La location a échoué, veuillez réessayer',
    title: "Veuillez confirmer l'autorisation",
    policy: 'Politique.',
    term: ' Termes et conditions',
    and: 'et',
    privacy: 'Politique de confidentialité.',
    tips: 'En continuant, vous acceptez notre',
    cancel: 'ANNULER',
    agree: 'ACCEPTER'
  },
  preauth: {
    preauthortitle: 'À propos de la préautorisation',
    tip1: "Lors du démarrage d'une location, une pré-autorisation est effectuée sur votre moyen de paiement. Il s’agit simplement de garantir que vous disposez de fonds suffisants pour payer votre location.",
    tip2: "Votre banque peut vous envoyer une notification mais il ne s'agit pas de frais : seul le prix de votre location vous sera facturé.",
    tip3: "Selon votre banque, l'ajustement du montant sur vos relevés peut prendre de quelques heures à quelques jours, c'est normal."
  },
  rentcost: {
    rentcosttitle: 'Combien coûte la location ?',
    tip1: "Si vous ne retournez pas la banque d'alimentation dans les 48 heures, des frais de non-retour de {currency} {yajin} vous seront facturés.",
    tip2: 'La durée est arrondie à la demi-heure la plus proche (30 ou 60 minutes).',
    tip3: "La location d'une journée dure 24 heures à compter de la location de la banque d'alimentation.",
    tip3_1: 'Des frais de préautorisation de {currency}{currencyName} {cyajin} seront appliqués à votre mode de paiement. Ceci afin de garantir que vous disposez de fonds suffisants pour payer votre location.',
    tip3_2: "Votre banque peut vous envoyer une notification, mais il ne s'agit pas de frais ; seul le prix de votre location vous sera facturé.",
    tip3_3: "Selon votre banque, l'ajustement du montant sur vos relevés peut prendre quelques heures, voire quelques jours.",
    tip4: 'Certains sites peuvent offrir des heures gratuites ou des réductions. Apprécier!',
    Days: 'Jours',
    Hours: 'Heures',
    Minutes: 'Minutes'
  },
  logincode: {
    login: 'Se connecter',
    retry: 'Renvoyer',
    title: 'Le code de vérification',
    subtitle: 'Veuillez saisir le code de vérification que nous avons envoyé à votre numéro de téléphone'
  },
  agreenconfirm: {
    title: "Veuillez confirmer l'autorisation",
    policy: 'Politique.',
    term: "Conditions générales d'Eternal Technology",
    and: 'et',
    privacy: 'Politique de confidentialité.',
    tips: "Je suis d'accord avec",
    cancel: 'ANNULER',
    agree: 'ACCEPTER'
  },
  users: {
    username: "Nom d'utilisateur",
    mobile: 'Mobile',
    login: 'Se connecter',
    orders: 'Commandes de location',
    wallet: 'Mon portefeuille',
    joinus: 'Coopération à rejoindre',
    langsetting: 'Paramètres de langue'
  },
  login: {
    login_fail: 'La connexion a échoué',
    phonenumber: 'Numéro de téléphone',
    verificationcode: 'Le code de vérification',
    Rentpowerbank: "Louer une banque d'alimentation",
    Rentpowerbanktip: 'Entrez votre numéro de téléphone portable pour commencer',
    phone_number: 'Veuillez saisir un numéro de mobile à {0} chiffres',
    captcha_code: 'Code',
    send_code: 'Envoyer le code',
    login: 'Se connecter',
    agree: 'En cliquant sur Connexion, vous acceptez',
    readme: `Accord de l'utilisateur`,
    msg_fail_login: 'La connexion a échoué',
    msg_success_login: 'Connexion réussie',
    msg_success_login_code: "Reçu avec succès, veuillez télécharger l'application pour vous connecter et utiliser",
    msg_fail_user: "Erreur lors de l'obtention des informations utilisateur. Voulez-vous essayer à nouveau?",
    no_sms: "Je n'ai pas reçu de SMS",
    retry: 'Renvoyer',
    receive: 'Appliquer',
    invite_pwd: "Code d'invitation",
    vip_agreen_tip: 'En continuant, vous indiquez que vous acceptez notre',
    vip_agreen_service: "Conditions d'utilisation",
    vip_agreen_and: 'et',
    vip_agreen_policy: 'politique de confidentialité'
  },
  confirm: {
    title: 'Confirmation de paiement',
    pay_label: 'Montant',
    addcard: 'Ajouter une carte portefeuille',
    price_tips: 'Cliquez pour confirmer le paiement, indiquant que vous avez lu et accepté le ',
    price_btn: '《Accord à valeur ajoutée》',
    pay_type: 'Veuillez sélectionner votre mode de paiement préféré',
    submit: 'Confirmer le bail',
    charge: 'Confirmer la recharge',
    msg_fail_title: 'Avertissement',
    msg_fail_order: 'Échec de la création de la commande de location',
    msg_fail_confirm: 'Confirmer',
    msg_fail_retry: 'Recommencez',
    msg_fail_cancel: 'Annuler',
    confirmpay: 'Confirmer le paiement'
  },
  join: {
    title: 'Partenariat',
    call: 'Appel',
    tips: 'veuillez fournir vos informations, nous vous contacterons sous peu!',
    type1: 'Installation',
    type2: 'Publicité',
    type3: 'Autre',
    shop_name: 'Nom du commerçant',
    contact_person: 'Personne de contact',
    phone: 'Numéro de contact',
    submit: 'Soumission',
    noempty: 'Ne peux pas être vide'
  },
  mine: {
    title: "Profil de l'utilisateur",
    wallet: 'Mon portefeuille',
    balance: 'Mon solde',
    mywalletcard: 'Ma carte',
    addcard: 'Ajouter une carte portefeuille',
    deposit: 'Dépôt',
    wallet_in: 'Charge',
    wallet_out: 'Retirer',
    wallet_log: 'Journal du portefeuille',
    order: 'Commande',
    login_tips: 'Veuillez vous connecter',
    msg_fail_title: 'Erreur',
    msg_fail_user: "Erreur lors de l'obtention des informations utilisateur. Voulez-vous essayer à nouveau?",
    help: 'Aide',
    setting: 'Paramètre',
    logout: 'Se déconnecter',
    unpaid: 'Non payé',
    using: 'Utilisé',
    getcabinetConfig: "Aucune information sur les prix n'a encore été obtenue, veuillez d'abord vous connecter"

  },
  msg: {
    nopaymode: "L'acquisition du mode de paiement a échoué",
    unlogin: "Vous n'êtes pas encore connecté, veuillez vous connecter",
    msg_fail_title: 'Avertissement',
    deletecard: 'Etes-vous sûr de supprimer cette carte ?',
    loading: 'Chargement...',
    title: 'Conseils',
    success: 'Opération réussie',
    error: 'Erreur inconnue, veuillez réessayer plus tard.',
    userinfo_fail: 'Informations utilisateur invalides, veuillez vous reconnecter',
    roleerror: "Autorisations insuffisantes, veuillez consulter l'administrateur",
    neterror: 'La connexion réseau a échoué. Veuillez réessayer plus tard',
    confirm: 'Confirmer',
    retry: 'Recommencez',
    cancel: 'Annuler',
    msg_logout: 'Êtes-vous sûr de quitter le compte ?',
    vieworder: "Voir l'ordre",
    addorselectcard: 'Veuillez ajouter ou sélectionner un paquet de cartes pour continuer',
    success_payment: 'Paiement terminé',
    fail_payment: 'Échec de paiement',
    keyword: 'mot-clé',
    unpaid_order: 'Il y a des commandes impayées',
    go_pay: 'Allez payer',
    no_more: 'pas plus',
    noshop: 'Aucun commerçant',
    msg_fail_code: "entrez le code de vérification S'il vous plait",
    msg_fail_phone: 'Veuillez entrer votre numéro de téléphone',
    exceedorder: 'Vous avez déjà une commande en location, merci de la retourner avant de continuer',
    sendsuccess: 'Réussie Envoyer',
    copysuccess: 'Répliquer le succès'
  },
  result: {
    title: 'Location confirmée',
    tips: "Pour consulter les commandes et les autres emplacements des stations, veuillez télécharger l'application.",
    download: 'TÉLÉCHARGER',
    vieworder: "Voir l'ordre",
    msg_result_loading: 'Le résultat du paiement est en cours de confirmation...',
    msg_tips_loading: 'La batterie portable apparaît, veuillez patienter patiemment...',
    haveorder: "L'ordre officiel a été généré",
    loading_title: 'La batterie portable apparaît',
    loading_tips: 'veuillez patienter patiemment...',
    send: 'Envoyer',
    email_tips: 'Vous pouvez laisser votre email et nous vous enverrons les détails de cette commande à votre email',
    email: 'E-Mail'
  },
  result_msg: {
    loading: 'Chargement...',
    refresh: 'Rafraîchir'
  },
  order: {
    title: 'Ordonnance de location',
    in_use: 'Utilisé',
    ended: 'Terminé',
    msg_error: 'Demande échoué',
    no_data: 'Pas de données'
  },
  order_item: {
    order_number: 'Non.',
    venue_rented: 'Lieu loué',
    time_rented: 'Temps loué',
    venue_returned: 'Lieu rendu',
    time_returned: 'Le temps est revenu',
    charge_standard: 'Norme de facturation',
    rent_occurred: 'Le loyer a eu lieu',
    returned: 'Revenu',
    unreturned: 'Non retourné',
    type_0: 'Pas achevé',
    type_1: 'Location',
    type_2: 'Annulé',
    type_3: 'Revenu',
    type_4: "Un défaut s'est produit",
    type_5: 'Au fil du temps',
    min: 'Min..',
    unpaid: 'Non payé',
    payment: 'Paiement'
  },
  setting: {
    title: 'Paramètre',
    lang: 'Langue'
  },
  help: {
    title: 'FAQ'
  },
  wallet_in: {
    title: 'Ajouter de la valeur',
    price_label: 'Veuillez sélectionner un autre montant de recharge',
    price_placeholder: 'veuillez entrer le montant de la recharge',
    balance: 'Équilibre',
    chargemoney: 'Veuillez sélectionner le montant de la recharge',
    submit: 'Soumettre',
    loading: 'Chargement ...',
    msg_title: 'Rappel'
  },
  wallet_out: {
    title: 'Retrait',
    price_label: 'Veuillez saisir le montant du retrait',
    price_placeholder: 'Veuillez saisir le montant du retrait',
    balance: 'Solde actuel',
    balance_all: 'Tout retirer',
    deposit: 'Dépôt',
    deposit_tips: "Il y a un ordre de location. Le dépôt de {pcurrencyName}{pyajin} n'est pas remboursable",
    submit: 'Soumettre',
    apply: 'Appliquer',
    confirm: 'Confirmer',
    loading: 'Chargement...',
    msg_fail_price: 'Le montant du retrait est incorrect',
    msg_fail_balance: 'Le montant du retrait ne peut pas être supérieur au solde actuel',
    msg_title: 'Erreur',
    msg_success_content: 'Demande de remboursement réussie',
    tips_title: 'Explication',
    btn: 'Soumettre',
    error_tips: 'Veuillez saisir les informations complètes'
  },
  orderDetail: {
    price1: '{pCurrencyName}{pJifei} par {pJifeiDanwei}{priceUnit}',
    price2: 'Jusqu\'à {pCurrencyName}{pFengding} par 24 heures',
    price3: 'Frais de non-retour de {pCurrencyName}{overtimeAmount}',
    venuerented: 'Lieu loué',
    venuereturned: 'Retour du lieu',
    timerented: 'Temps loué',
    timereturned: 'Le temps est revenu',
    getreceipt: 'OBTENIR UN REÇU',
    buypowerbank: 'Achetez cette banque d\'alimentation',
    usetime: 'Utiliser le temps',
    estimatedamount: 'Montant estimé',
    feerule: 'Règle des frais',
    onrental: 'En location',
    revoked: 'Révoqué',
    returned: 'De retour',
    issue: 'Problème',
    overtimereturn: 'Temps mort'
  }
}
